import { ApplicationHandoverModel } from "./HandoverModel";

export enum WIPStatus {
  AwaitingPayout = "Awaiting Payout",
  DocsOut = "Docs Out",
  OrderSent = "Order Sent",
}

export enum OtherStatus {
  Verified = "Verified",
  Awaiting = "Awaiting",
  Uploaded = "Uploaded",
  Snagged = "Snagged",
  NotRequired = "N/A",
  Complete = "Complete",
  Incomplete = "Incomplete",
}

export interface WIPModel extends ApplicationHandoverModel {
  applicationId: number;
  allocatedAgentName: string;
  customerName: string;
  isPredictedToPay: boolean;
  allocatedPayoutAgent: string;
  status: WIPStatus;
  customerDocsStatus: OtherStatus | string;
  dealerDocsStatus: OtherStatus | string;
  financeDocsStatus: OtherStatus | string;
  lastNote?: string | null;
}
